import _extends from '../../../node_modules/@babel/runtime/helpers/esm/extends.js';
import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import React__default, { useRef, useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import ArrowBackIcon from '../streamline-icon/ArrowBackIcon.js';
import ArrowForwardIcon from '../streamline-icon/ArrowForwardIcon.js';
import CustomIconButton from '../button/custom-icon-button/CustomIconButton.js';
import { makeStyles, Box, Typography } from '@material-ui/core';
import PropTypes__default from 'prop-types';
import MediaCard from '../card/MediaCard.js';

var useStyles = makeStyles(function (theme) {
  return {
    sliderContainer: {
      "& .slick-track": {
        display: "flex",
        paddingBottom: theme.spacing(3)
      },
      "& .slick-slide": {
        height: "auto",
        "& > div": {
          height: "100%",
          margin: theme.spacing(1)
        }
      }
    },
    title: {
      textAlign: "center"
    },
    arrowBtn: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      border: "1px solid #D8D5D0;"
    },
    outOfFocusCard: {
      opacity: "0.6"
    },
    sliderContainerWrapper: {
      width: "100%"
    }
  };
});
var CardSlider = function CardSlider(_ref) {
  var title = _ref.title,
    cards = _ref.cards,
    sliderOpts = _ref.sliderOpts,
    highlightFocused = _ref.highlightFocused,
    sliderContainerClassName = _ref.sliderContainerClassName;
  var classes = useStyles();
  var sliderRef = useRef();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];

  // Show middle card as focused if only 3 elements and
  // highlightFocused is true
  useEffect(function () {
    if (sliderRef.current && cards.length === 3 && highlightFocused) {
      sliderRef.current.slickGoTo(1);
      setActiveIndex(1);
    }
  }, [cards, sliderRef, highlightFocused]);
  var getClassName = function getClassName(currIndex) {
    if (highlightFocused) {
      return currIndex !== activeIndex ? classes.outOfFocusCard : undefined;
    }
    return undefined;
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.isValidElement(title) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, title) : /*#__PURE__*/React__default.createElement(Box, {
    mb: 5,
    className: classes.title
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h2"
  }, title)), /*#__PURE__*/React__default.createElement(Box, {
    className: sliderContainerClassName ? sliderContainerClassName : classes.sliderContainerWrapper
  }, /*#__PURE__*/React__default.createElement(Slider, _extends({}, sliderOpts, {
    ref: sliderRef,
    className: classes.sliderContainer,
    afterChange: function afterChange(index) {
      return setActiveIndex(index);
    }
  }), cards === null || cards === void 0 ? void 0 : cards.map(function (card, index) {
    return /*#__PURE__*/React__default.createElement(MediaCard, {
      className: getClassName(index),
      key: index,
      title: card === null || card === void 0 ? void 0 : card.title,
      overtitle: card === null || card === void 0 ? void 0 : card.overtitle,
      subtitle: card === null || card === void 0 ? void 0 : card.subtitle,
      content: card === null || card === void 0 ? void 0 : card.content,
      image: card === null || card === void 0 ? void 0 : card.image,
      variant: card === null || card === void 0 ? void 0 : card.variant,
      footer: card === null || card === void 0 ? void 0 : card.footer,
      chip: card === null || card === void 0 ? void 0 : card.chip,
      elevation: index === activeIndex && highlightFocused ? 6 : card === null || card === void 0 ? void 0 : card.elevation
    });
  }))), /*#__PURE__*/React__default.createElement(Box, {
    mt: 5,
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(CustomIconButton, {
    disableRipple: true,
    onClick: function onClick() {
      return sliderRef.current.slickPrev();
    },
    className: classes.arrowBtn
  }, /*#__PURE__*/React__default.createElement(ArrowBackIcon, null)), /*#__PURE__*/React__default.createElement(Box, {
    ml: 2
  }, /*#__PURE__*/React__default.createElement(CustomIconButton, {
    disableRipple: true,
    onClick: function onClick() {
      return sliderRef.current.slickNext();
    },
    className: classes.arrowBtn
  }, /*#__PURE__*/React__default.createElement(ArrowForwardIcon, null)))));
};
CardSlider.defaultProps = {
  sliderOpts: {
    dots: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true
  },
  highlightFocused: false
};
CardSlider.propTypes = {
  title: PropTypes__default.string,
  cards: PropTypes__default.array,
  sliderOpts: PropTypes__default.object,
  highlightFocused: PropTypes__default.bool,
  sliderContainerClassName: PropTypes__default.any
};

export { CardSlider as default };
//# sourceMappingURL=CardSlider.js.map
